import(/* webpackMode: "eager", webpackExports: ["Dashboard"] */ "/vercel/path0/components/Dashboard/Dashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HomeProvider","HomeWrapperContext"] */ "/vercel/path0/components/Home/Home.provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageWrapper"] */ "/vercel/path0/components/PageWrapper/PageWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/vercel/path0/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
